import styled from 'styled-components';

import { FlexParentBlock } from '../../../styled';

export const Wrapper = styled.div`
  margin-top: 44px;
`;

export const ErrorWrapper = styled(FlexParentBlock)<{ isModal: boolean }>`
  gap: ${(props) => (props.isModal ? '10px' : '20px')};
  align-items: center;

  > div {
    margin-top: 0;
  }

  > div > span {
    margin-left: 8px;
  }

  ${(props) => props.isModal && 'padding-left: 20px'};
`;
